<template>
  <v-row class="ma-0 text-center" justify="center" align="center">
    <v-img class="mt-4" contain max-height="80" max-width="100" :src="logo" />
    <v-col cols="12" class="text-footer">
      Need Help? Contact:
      <a href="mailto:support@eblity.com?subject=Need Help&body="
        >support@eblity.com</a
      >
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "PageFooter",
    components: {},
    data() {
      return {
        logo: require("@/assets/EblityLogo.png"),
      };
    },
    created() {},
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped>
.text-footer{
  font-size: 12px;
}
</style>
